import { GeneralWord, JapaneseExtraString, LangCodeDescription, LangWordStringInterface } from 'src/app/core/lexicore/lexicore.classes';

export function completeWordWithAIPrompt(word: GeneralWord, target: string) {
  const targetLanguage = LangCodeDescription[target];

  let prompt = `
  You are a helpful assistant that completes a word form with the missing information.
  The word is: ${word.word || ''}
  all the information you give should be in ${targetLanguage}
  return the information in JSON following the interface:
  ${LangWordStringInterface}
  `;

  if (targetLanguage === 'ja') {
    prompt += `
    also include in the same JSON this data and small examples for beginners in japanese:
    ${JapaneseExtraString}
    `;
  }

  return prompt;
}
